import { render } from "./CardStatusVehicle.vue?vue&type=template&id=46221d57"
import script from "./CardStatusVehicle.vue?vue&type=script&lang=js"
export * from "./CardStatusVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script